// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Barlow-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/Barlow-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/Barlow-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/Nelphim.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Barlow";
  src: local("Barlow"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "BarlowLight";
  src: local("BarlowLight"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "BarlowBold";
  src: local("BarlowBold"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}

@font-face {
  font-family: "Nelphim";
  src: local("Nelphim"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2");
}

/*Desktop View*/
.style-header {
  height: 80px;
  background-color: #ecebe5;
  display: block;
  width: 100vw;
}

header.style-header.affix {
  background: rgba(236, 235, 230, 0.4);
  backdrop-filter: blur(10px);
  position: sticky;
  top: 0px;
  z-index: 1080;
  display: block;
  width: 100vw;
  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;
}

.header-bg {
  max-width: 1366px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
}

.header-group {
  width: calc(100% - 120px);
  height: 100%;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  align-items: center;
}

.logo-nav {
  width: 30%;
  display: flex;
  align-items: center;
}

.nav-mobile-title {
  display: none;
}

.nav-menu {
  display: flex;
  align-items: center;
  width: 70%;
  justify-content: flex-end;
}

.nav-options {
  display: flex;
  align-items: center;
  list-style-type: none;
}

.nav-options .nav-options-group {
  display: inline-flex;
  gap: 16px;
  padding: 0px 16px;
}

.nav-options .nav-options-group .option a {
  border-radius: 30px;
  padding: 12px 24px;
  display: block;
  color: #494949;
  text-decoration: none;
}

.nav-options .nav-options-group .option a:hover {
  color: white;
  background-color: #7ba7c2;
}

.contact-web {
  display: flex;
}

.contact-web li {
  list-style-type: none;
}

.contact-web li a {
  color: #fff !important;
}

.nav-primary {
  background-color: #7ba7c2;
  color: #fff !important;
  border-radius: 30px;
  padding: 12px 24px;
  display: block;
  list-style-type: none;
  text-decoration: none;
}

.mobile-option {
  display: none;
}

.contact-web {
  display: flex;
}

.contact-web li {
  list-style-type: none;
}

.mobile-menu {
  display: none;
}



.dropdown-web {
  cursor: pointer;
  border-radius: 30px;
  padding: 12px 24px;
  display: block;
  color: #494949;
}

.dropdown-menu {
  margin-top: 12px;
  background: rgba(236, 235, 230, 0.9);
  backdrop-filter: blur(10px);
  transition: all linear 0.3s;
  position: absolute;
  z-index: 2;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;
  padding: 24px;
  border-radius: 20px;
}

.dropdown-menu ul li {
  list-style: none;
}

.dropdown-mobile {
  display: none;
}

@media only screen and (max-device-width: 768px) {
  .logo-nav {
    width: 20%;
  }

  .logo-nav a img {
    width: 100%;
  }

  .nav-menu {
    width: 80%;
  }

  .nav-options {
    display: flex;
    align-items: center;
    list-style-type: none;
  }

  .nav-options .nav-options-group {
    display: inline-flex;
    gap: 8x;
    padding: 0px 8px;
  }

  .nav-options .nav-options-group .option a {
    border-radius: 20px;
    padding: 12px 10px;
    display: block;
    color: #494949;
    font-family: "Barlow";
  }

  .nav-options .nav-options-group .option a:hover {
    color: white;
    background-color: #7ba7c2;
  }

  .nav-primary {
    border-radius: 20px;
    padding: 12px 10px;
  }
}

@media only screen and (max-device-width: 480px) {

  /*Mobile View */
  .header-bg {
    padding: 0px 30px;
  }

  .header-group {
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .logo-nav {
    width: 50%;
  }

  .logo-nav a img {
    width: 100%;
  }

  .nav-menu {
    display: block;
    align-items: unset;
    width: unset;
  }

  .nav-mobile-title {
    margin-top: 100px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
  }

  .nav-mobile-title svg {
    color: #fff;
  }

  .mobile-logo {
    width: 70%;
  }

  .nav-options {
    display: block;
    width: calc(100% - 60px);
    height: 100vh;
    position: absolute;
    top: 0px;
    left: -100%;
    opacity: 0;
    transition: all 0.5s ease;
    flex-direction: unset;
    list-style-type: none;
    grid-gap: 0px;
    z-index: 100;
  }

  .nav-options a {
    width: 100%;
  }

  .nav-options.active {
    background: rgba(123, 167, 194, 0.7);
    backdrop-filter: blur(10px);
    left: 0;
    opacity: 1;
    transition: all 0.5s ease;
    z-index: 100;
    align-content: unset;
    padding: 0px 30px;
    margin-bottom: 30px;
  }

  .nav-options-group {
    margin-top: 100px;
    display: block !important;
    padding: 0px !important;
  }

  .nav-options-group .option {
    display: flex;
    align-items: center;
    height: unset;
    margin-bottom: 60px;
    text-align: left;
    justify-content: flex-start;
    text-align: left;
  }

  .nav-options-group .option a {
    color: #fff !important;
    padding: 0px !important;
    font-family: "Nelphim" !important;
    font-size: 2em !important;
  }

  .nav-options-group .option a:active,
  .nav-options-group .option a:hover {
    color: #fff !important;
    background-color: unset !important;
    padding: 0px !important;
  }

  .nav-primary {
    background-color: #7ba7c2;
    color: #fff !important;
    border-radius: 30px;
    padding: 10px 12px;
    display: block;
    list-style-type: none;
  }

  .menu-icon {
    width: 45px;
    height: 45px;
  }

  .contact-web {
    display: none;
  }

  .mobile-menu {
    display: flex;
    align-items: center;
  }

  .contact-mobile {
    display: flex;
    align-items: center;
    list-style-type: none;
  }

  .menu-toggle {
    margin-left: 20px;
    height: 100%;
    display: flex;
    align-items: center;
  }

  .dropdown-web {
    display: none !important;
  }

  .dropdown-mobile {
    display: block !important;
    color: #fff !important;
    padding: 0px !important;
    font-family: "Nelphim" !important;
    font-size: 2em !important;
  }

  .dropdown-mobile .dropdown-menu {
    margin-top: 12px;
    background: none;
    backdrop-filter: none;
    transition: all linear 0.3s;
    position: relative;
    z-index: 2;
    box-shadow: none;
    padding: 0px;
    border-radius: 0px;
  }

  .dropdown-mobile .dropdown-menu ul li a {
    list-style: none;
    font-family: "Nelphim" !important;
    font-size: 0.9em !important;
    margin-bottom: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/style/header.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,4EAAwE;AAC1E;;AAEA;EACE,0BAA0B;EAC1B,iFAA2E;AAC7E;;AAEA;EACE,yBAAyB;EACzB,gFAA2E;AAC7E;;AAEA;EACE,sBAAsB;EACtB,8EAAoE;AACtE;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,YAAY;EACZ,gEAAgE;AAClE;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,8HAA8H;EAC9H,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,OAAO;IACP,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA;;EAEE,eAAe;EACf;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,wBAAwB;IACxB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,aAAa;IACb,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,oCAAoC;IACpC,2BAA2B;IAC3B,OAAO;IACP,UAAU;IACV,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,yBAAyB;IACzB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;;IAEE,sBAAsB;IACtB,kCAAkC;IAClC,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,sBAAsB;IACtB,uBAAuB;IACvB,iCAAiC;IACjC,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,2BAA2B;IAC3B,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,2BAA2B;IAC3B,mBAAmB;EACrB;AACF","sourcesContent":["@font-face {\n  font-family: \"Barlow\";\n  src: local(\"Barlow\"), url(\"../fonts/Barlow-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowLight\";\n  src: local(\"BarlowLight\"), url(\"../fonts/Barlow-Light.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"BarlowBold\";\n  src: local(\"BarlowBold\"), url(\"../fonts/Barlow-Medium.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Nelphim\";\n  src: local(\"Nelphim\"), url(\"../fonts/Nelphim.woff2\") format(\"woff2\");\n}\n\n/*Desktop View*/\n.style-header {\n  height: 80px;\n  background-color: #ecebe5;\n  display: block;\n  width: 100vw;\n}\n\nheader.style-header.affix {\n  background: rgba(236, 235, 230, 0.4);\n  backdrop-filter: blur(10px);\n  position: sticky;\n  top: 0px;\n  z-index: 1080;\n  display: block;\n  width: 100vw;\n  animation: 500ms ease-in-out 0s normal none 1 running fadeInDown;\n}\n\n.header-bg {\n  max-width: 1366px;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n  height: 100%;\n}\n\n.header-group {\n  width: calc(100% - 120px);\n  height: 100%;\n  margin-left: auto;\n  margin-right: auto;\n  display: flex;\n  align-items: center;\n}\n\n.logo-nav {\n  width: 30%;\n  display: flex;\n  align-items: center;\n}\n\n.nav-mobile-title {\n  display: none;\n}\n\n.nav-menu {\n  display: flex;\n  align-items: center;\n  width: 70%;\n  justify-content: flex-end;\n}\n\n.nav-options {\n  display: flex;\n  align-items: center;\n  list-style-type: none;\n}\n\n.nav-options .nav-options-group {\n  display: inline-flex;\n  gap: 16px;\n  padding: 0px 16px;\n}\n\n.nav-options .nav-options-group .option a {\n  border-radius: 30px;\n  padding: 12px 24px;\n  display: block;\n  color: #494949;\n  text-decoration: none;\n}\n\n.nav-options .nav-options-group .option a:hover {\n  color: white;\n  background-color: #7ba7c2;\n}\n\n.contact-web {\n  display: flex;\n}\n\n.contact-web li {\n  list-style-type: none;\n}\n\n.contact-web li a {\n  color: #fff !important;\n}\n\n.nav-primary {\n  background-color: #7ba7c2;\n  color: #fff !important;\n  border-radius: 30px;\n  padding: 12px 24px;\n  display: block;\n  list-style-type: none;\n  text-decoration: none;\n}\n\n.mobile-option {\n  display: none;\n}\n\n.contact-web {\n  display: flex;\n}\n\n.contact-web li {\n  list-style-type: none;\n}\n\n.mobile-menu {\n  display: none;\n}\n\n\n\n.dropdown-web {\n  cursor: pointer;\n  border-radius: 30px;\n  padding: 12px 24px;\n  display: block;\n  color: #494949;\n}\n\n.dropdown-menu {\n  margin-top: 12px;\n  background: rgba(236, 235, 230, 0.9);\n  backdrop-filter: blur(10px);\n  transition: all linear 0.3s;\n  position: absolute;\n  z-index: 2;\n  box-shadow: rgba(0, 0, 0, 0.2) 0px 11px 15px -7px, rgba(0, 0, 0, 0.14) 0px 24px 38px 3px, rgba(0, 0, 0, 0.12) 0px 9px 46px 8px;\n  padding: 24px;\n  border-radius: 20px;\n}\n\n.dropdown-menu ul li {\n  list-style: none;\n}\n\n.dropdown-mobile {\n  display: none;\n}\n\n@media only screen and (max-device-width: 768px) {\n  .logo-nav {\n    width: 20%;\n  }\n\n  .logo-nav a img {\n    width: 100%;\n  }\n\n  .nav-menu {\n    width: 80%;\n  }\n\n  .nav-options {\n    display: flex;\n    align-items: center;\n    list-style-type: none;\n  }\n\n  .nav-options .nav-options-group {\n    display: inline-flex;\n    gap: 8x;\n    padding: 0px 8px;\n  }\n\n  .nav-options .nav-options-group .option a {\n    border-radius: 20px;\n    padding: 12px 10px;\n    display: block;\n    color: #494949;\n    font-family: \"Barlow\";\n  }\n\n  .nav-options .nav-options-group .option a:hover {\n    color: white;\n    background-color: #7ba7c2;\n  }\n\n  .nav-primary {\n    border-radius: 20px;\n    padding: 12px 10px;\n  }\n}\n\n@media only screen and (max-device-width: 480px) {\n\n  /*Mobile View */\n  .header-bg {\n    padding: 0px 30px;\n  }\n\n  .header-group {\n    width: 100%;\n    height: 100%;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .logo-nav {\n    width: 50%;\n  }\n\n  .logo-nav a img {\n    width: 100%;\n  }\n\n  .nav-menu {\n    display: block;\n    align-items: unset;\n    width: unset;\n  }\n\n  .nav-mobile-title {\n    margin-top: 100px;\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .nav-mobile-title svg {\n    color: #fff;\n  }\n\n  .mobile-logo {\n    width: 70%;\n  }\n\n  .nav-options {\n    display: block;\n    width: calc(100% - 60px);\n    height: 100vh;\n    position: absolute;\n    top: 0px;\n    left: -100%;\n    opacity: 0;\n    transition: all 0.5s ease;\n    flex-direction: unset;\n    list-style-type: none;\n    grid-gap: 0px;\n    z-index: 100;\n  }\n\n  .nav-options a {\n    width: 100%;\n  }\n\n  .nav-options.active {\n    background: rgba(123, 167, 194, 0.7);\n    backdrop-filter: blur(10px);\n    left: 0;\n    opacity: 1;\n    transition: all 0.5s ease;\n    z-index: 100;\n    align-content: unset;\n    padding: 0px 30px;\n    margin-bottom: 30px;\n  }\n\n  .nav-options-group {\n    margin-top: 100px;\n    display: block !important;\n    padding: 0px !important;\n  }\n\n  .nav-options-group .option {\n    display: flex;\n    align-items: center;\n    height: unset;\n    margin-bottom: 60px;\n    text-align: left;\n    justify-content: flex-start;\n    text-align: left;\n  }\n\n  .nav-options-group .option a {\n    color: #fff !important;\n    padding: 0px !important;\n    font-family: \"Nelphim\" !important;\n    font-size: 2em !important;\n  }\n\n  .nav-options-group .option a:active,\n  .nav-options-group .option a:hover {\n    color: #fff !important;\n    background-color: unset !important;\n    padding: 0px !important;\n  }\n\n  .nav-primary {\n    background-color: #7ba7c2;\n    color: #fff !important;\n    border-radius: 30px;\n    padding: 10px 12px;\n    display: block;\n    list-style-type: none;\n  }\n\n  .menu-icon {\n    width: 45px;\n    height: 45px;\n  }\n\n  .contact-web {\n    display: none;\n  }\n\n  .mobile-menu {\n    display: flex;\n    align-items: center;\n  }\n\n  .contact-mobile {\n    display: flex;\n    align-items: center;\n    list-style-type: none;\n  }\n\n  .menu-toggle {\n    margin-left: 20px;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n\n  .dropdown-web {\n    display: none !important;\n  }\n\n  .dropdown-mobile {\n    display: block !important;\n    color: #fff !important;\n    padding: 0px !important;\n    font-family: \"Nelphim\" !important;\n    font-size: 2em !important;\n  }\n\n  .dropdown-mobile .dropdown-menu {\n    margin-top: 12px;\n    background: none;\n    backdrop-filter: none;\n    transition: all linear 0.3s;\n    position: relative;\n    z-index: 2;\n    box-shadow: none;\n    padding: 0px;\n    border-radius: 0px;\n  }\n\n  .dropdown-mobile .dropdown-menu ul li a {\n    list-style: none;\n    font-family: \"Nelphim\" !important;\n    font-size: 0.9em !important;\n    margin-bottom: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
